export default (list) => {
  const roles = list.map(role => {
    if (window.allowedRoles[window.product].map(x => x.role).indexOf(role.name) !== -1) {
      return role
    }
  }).filter(Boolean)
  return roles
}
